import { InputImage } from '@eliadmin/core/src/components/ui/input-image';
import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    leadingIcon: (
      <button
        type="button"
        aria-label="Vyhľadať"
        className="ml-2 flex h-6 min-w-6 items-center justify-center"
      >
        <InputImage alt="" src="/images/icons/input-search.svg" />
      </button>
    ),
    showButton: false,
    placeholder: 'Vyhľadajte...',
    inputWrapperClassName:
      'border-e-none h-12 rounded-full pr-1 focus-within:border-2 focus-within:border-primary ea-search-bar__input',
    className: {
      root: 'rounded-full bg-input',
      input: {
        main: 'rounded-full pl-[52px] text-sm font-normal placeholder:text-[#9E9E9E] lg:text-base',
      },
    },
  },
};
